import React, {type PropsWithChildren} from 'react';
interface MainLayoutProps extends PropsWithChildren {
    showMore?: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({children, showMore}) => {
    return (
        <>
            <main className="w-full mb-4 md:mt-0 md:pb-0 relative bg-white flex flex-col overflow-hidden gap-y-4 md:gap-y-6">
                {children}
                {showMore}
            </main>
        </>
    );
};

export default MainLayout;